import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { isIE11 } from 'src/app/shared/detect-ie11';
import { Select } from '@ngxs/store';
import { ViewState } from 'src/app/view/state/view.state';
import { Observable, Subject } from 'rxjs';
import { ViewUIModel } from 'src/app/view/models/view-ui.model';
import { takeUntil } from 'rxjs/operators';
import { StorageService, StorageItemEnum } from 'src/app/shared/storage.service';

@Component({
  selector: 'app-ie-warning',
  templateUrl: './ie-warning.component.html',
  styleUrls: ['./ie-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class IeWarningComponent implements OnInit, OnDestroy {
  @Select(ViewState.getUI)
  layout$: Observable<ViewUIModel>;


  constructor(
    private changeDetector: ChangeDetectorRef,
    private storageService: StorageService
  ) { }
  
  show = false;
  message = `For the full interactive 3D experience please try loading this content in Chrome or Firefox.`;
  ngUnsubscribe = new Subject();

  ngOnInit() {
    this.initLayoutListener();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleDismissClick() {
    this.show = false;
    this.storageService.setLocalItem(StorageItemEnum.InternetExplorerWarning, true);
  }

  shouldShow(layout: ViewUIModel) {
    const cookie = this.storageService.getLocalItem(StorageItemEnum.InternetExplorerWarning);

    // Only show if
    // - We're using IE11
    // - The user hasn't previously dismissed the message
    // - The message hasn't been disabled in the URL params
    return isIE11() && !cookie && layout.internetExplorerWarning.enable;
  }

  initLayoutListener() {
    this.layout$
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(layout => {
        this.show = this.shouldShow(layout);
        this.changeDetector.markForCheck();
      });
  }
}
